<template>
    <div class="section section-shaped section-zero min-vh-100 d-flex justify-content-center align-items-center"
         :class=" type_active === 'remember' || type_active === 'login-token'? 'large-one' : 'large-two'">
        <div class="shape shape-style-1 bg-gradient-lighter">
        </div>
        <div class="row justify-content-center container">
            <div class="col-12 col-lg-9 container-main shadow" v-if="type_active !== 'not-have-permission'">

                <div class="content-box content-login" v-if="type_active === 'login' || type_active === 'register'">
                    <span class="title">{{ $t('ct-login')}}</span>
                    <login @change="changeType" @back="back"></login>

                    <div><a href="#" class="text-forgot-password" @click.prevent="changeType('remember')">{{
                        $t('ct-forgot-password')}}</a></div>
                </div>

                <div class="content-box content-login" v-if="type_active === 'login' || type_active === 'register'">
                    <span class="title">{{ $t('ct-register')}}</span>
                    <register :areas_register="areas_register" @change="changeType" @back="back"></register>
                </div>

                <div class="content-box content-forgot forgot" v-if="type_active === 'remember'">
                    <span class="title">{{ $t('ct-forgot-password') }}</span>
                    <remember-password @change="changeType" @back="back"></remember-password>

                    <div class="mx-5 mt-2 d-flex">
                        <div class="text-center flex-grow-1">
                            <a href="#" class="helper-forgot-password" @click.prevent="changeType('register')">{{
                                $t('ct-register')}}</a>
                            <span class="mx-1 helper-forgot-password">|</span>
                            <a href="#" class="helper-forgot-password" @click.prevent="changeType('login')">{{
                                $t('ct-sign-in')}}</a>
                        </div>
                    </div>
                </div>

                <div class="content-box content-forgot forgot" v-if="type_active === 'login-token'">
                    <span class="title">{{ $t('ct-access-with-token') }}</span>
                    <login-token @change="changeType" @back="back"></login-token>
                </div>
            </div>

            <div class="col-12 col-lg-6" v-else-if="type_active === 'not-have-permission'">
                <not-have-permission @back="back"></not-have-permission>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "TwoColumnsPage",
        props: ['type_active', 'areas_register', 'active_page'],
        methods: {

            back() {
                this.$emit('back')
            },

            changeType(active) {
                this.$emit('change', active)
            },

            getActualPage() {
                return this.active_page;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .title {
        display: block;
        text-align: left;
        font-size: 18px;
        margin-bottom: 15px;
    }

    /*.large-two{*/
    /*    width: auto;*/
    /*    @media (min-width: 851px) {*/
    /*        width: 800px;*/
    /*    }*/

    /*}*/

    /*.large-one{*/
    /*    width: auto;*/
    /*}*/
</style>